import { useState } from 'react'
import { lumi } from '../lib/lumi'

export interface Job {
  _id: string
  title: string
  companyName: string
  location: string
  type: 'Full-time' | 'Part-time' | 'Contract' | 'Freelance'
  salary: string
  category: 'teaching' | 'technology' | 'parttime'
  description: string
  tags: string[]
  featured: boolean
  active: boolean
  createdAt: string
  updatedAt: string
}

export const useJobs = () => {
  const [jobs, setJobs] = useState<Job[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchJobs = async (options?: {
    filter?: Record<string, any>
    sort?: Record<string, 1 | -1>
    limit?: number
    skip?: number
  }) => {
    setLoading(true)
    setError(null)
    try {
      const { list, total } = await lumi.entities.jobs.list({
        filter: { active: true, ...options?.filter },
        sort: options?.sort || { createdAt: -1 },
        limit: options?.limit || 50,
        skip: options?.skip || 0
      })
      setJobs(list)
      setTotal(total)
      console.log('Jobs fetched:', list.length, 'Total:', total)
    } catch (err) {
      console.error('Fetch jobs failed:', err)
      setError('Failed to load jobs')
    } finally {
      setLoading(false)
    }
  }

  const fetchFeaturedJobs = async () => {
    await fetchJobs({
      filter: { featured: true },
      sort: { createdAt: -1 },
      limit: 6
    })
  }

  const fetchJobsByCategory = async (category: string) => {
    if (category === 'all') {
      await fetchJobs({ limit: 50 })
    } else {
      await fetchJobs({
        filter: { category },
        limit: 50
      })
    }
  }

  const searchJobs = async (searchQuery: string) => {
    // In a real app, you'd use full-text search or regex
    // For now, we'll fetch all and filter client-side
    await fetchJobs()
  }

  return {
    jobs,
    total,
    loading,
    error,
    fetchJobs,
    fetchFeaturedJobs,
    fetchJobsByCategory,
    searchJobs
  }
}
